import { Injectable } from '@angular/core';
import { WebsocketInstance } from '../interface/websocketinstance';
import { webSocket } from 'rxjs/webSocket';
@Injectable({
  providedIn: 'root',
})
export class WebSocketConnectionService {
  connectionEstablish$;
  webSocketConnectionEstablish = false;
  constructor(private webConnection: WebsocketInstance) {}

  setResponceConnection = (setClass: WebsocketInstance) => {
    this.webConnection = setClass;
  };

  connectLiveSocket = (url, input) => {
    this.connectionEstablish$ = webSocket(url);
    this.connectionEstablish$.next(input);
    // console.log('websocket connected!');
    this.connectionEstablish$.subscribe(
      (res) => {
        this.webSocketConnectionEstablish = true;
        this.webConnection.webSocketResponce(res);
      },
      (err) => {
        this.webConnection.webSocketErrorReturn(err);
      },
      (close) => {
        // console.log('websocket closed!!' + close);
      }
    );
  };

  reRequestOnSameConnection = (input) => {
    this.connectionEstablish$.next(input);
  };

  closeConnection = () => {
    this.webSocketConnectionEstablish = false;
    this.connectionEstablish$.unsubscribe();
  };
}
